import { Color, Spacing, Text } from '@billy/design-system'
import { css } from '@emotion/core'
import styled from '@emotion/styled'

const DOT_DISTANCE_TOP = 8
const DOT_SIZE = 9
const SEPARATOR_DOT_DISTANCE = 13
const SEPARATOR_OFFSET = DOT_DISTANCE_TOP + DOT_SIZE + SEPARATOR_DOT_DISTANCE

interface TimelineStatusItemWrapperProps {
  statusColor: Color
  withSeparator: boolean
  withStatus: boolean
  isCollapsed: boolean
}

export const TimelineStatusItemWrapper = styled.div<TimelineStatusItemWrapperProps>`
  margin-bottom: ${Spacing.S8};
  position: relative;

  ${({ withSeparator, withStatus }) =>
    (withSeparator || withStatus) &&
    css`
      padding-left: ${Spacing.S16};
    `}

  ${({ isCollapsed, withSeparator }) =>
    !isCollapsed &&
    withSeparator &&
    css`
      min-height: 33px;
    `}

  ${({ withStatus, statusColor }) =>
    withStatus &&
    css`
      /* Status dot */
      &:before {
        content: '';
        width: ${DOT_SIZE}px;
        height: ${DOT_SIZE}px;
        border-radius: 50%;
        position: absolute;
        top: ${DOT_DISTANCE_TOP}px;
        left: 0;
        background-color: ${statusColor};
      }
    `}

  ${({ withSeparator }) =>
    withSeparator &&
    css`
      /* Vertical separator line */
      &:after {
        content: '';
        width: 1px;
        height: calc(100% - ${SEPARATOR_OFFSET}px);
        position: absolute;
        top: ${SEPARATOR_OFFSET}px;
        left: 4px;
        background-color: ${Color.Grey150};
      }
    `}
`

export const ChildrenWrapper = styled.div`
  margin-top: ${Spacing.S16};
`

// TODO retheming 2026 - get rid of (Text), which is an antipattern
export const DescriptionText = styled(Text)`
  line-height: 18px;
  ${({ truncate }) =>
    truncate &&
    css`
      white-space: pre-wrap;
    `}
`
